import { render, staticRenderFns } from "./BreadcrumbsNav.vue?vue&type=template&id=1ca78988&scoped=true&"
import script from "./BreadcrumbsNav.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsNav.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbsNav.vue?vue&type=style&index=0&id=1ca78988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca78988",
  null
  
)

export default component.exports